import { Route, Routes } from "react-router-dom";
import FeaturePages from "layout/FeaturePages";
import { RouteName } from "constant/routeNames";
import SubscriptionPlan from "./SubscriptionPlan/SubscriptionPlan";
import SeeAllMiniPackages from "./SubscriptionPlan/SeeAllMiniPackages";
import PackageDetailsPage from "./SubscriptionPlan/PackageDetailsPage";

const SubscriptionPlanPage = ({
  handleClick,
  isActive,
  setIsActive,
  anyPlayerActive,
}: any) => {
  return (
    <div className={`${anyPlayerActive ? `mb-[140px]` : `mb-30`}`}>
      <Routes>
        <Route
          path={RouteName.SubscriptionPlan}
          element={
            <FeaturePages
              Content={SubscriptionPlan}
              handleClick={handleClick}
              isActive={isActive}
              setIsActive={setIsActive}
              title={""}
              isFooter={false}
            />
          }
        />
        <Route
          path={RouteName.seeAllMiniSubscriptionPlan}
          element={
            <FeaturePages
              Content={SeeAllMiniPackages}
              handleClick={handleClick}
              isActive={isActive}
              setIsActive={setIsActive}
              title={""}
              isFooter={false}
            />
          }
        />
        <Route
          path={RouteName.packageDetailsPage}
          element={
            <FeaturePages
              Content={PackageDetailsPage}
              handleClick={handleClick}
              isActive={isActive}
              setIsActive={setIsActive}
              title={""}
              isFooter={false}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default SubscriptionPlanPage;
